import { ref } from 'vue';
import { useUserStore } from '~/stores/user';

const showContractModal = ref(false);
const patientContract = ref(null);
const contractUpdated = ref(false);

export const useContract = () => {
  const $axios = useNuxtApp().$axios;
  const userStore = useUserStore();

  const checkContract = async () => {
    try {
      const response = await $axios.get('/api/patient/contract');
      
      if (response.data.has_contract) {
        patientContract.value = response.data.contract;
        contractUpdated.value = response.data.requires_acceptance;
        
        if (response.data.requires_acceptance || !response.data.contract.accepted) {
          showContractModal.value = true;
        }
      }
    } catch (error) {
      console.error('Erro ao verificar contrato:', error);
    }
  };

  const loadContract = async () => {
    try {
      const response = await $axios.get('/api/v1/user/profile');
      
      if (response.data.contract_therapeutic) {
        patientContract.value = response.data.contract_therapeutic;
        userStore.contractTherapeutic = response.data.contract_therapeutic;
      }
    } catch (error) {
      console.error('Erro ao carregar contrato:', error);
    }
  };

  const openContractModal = async () => {
    await loadContract();
    showContractModal.value = true;
  };

  const closeContractModal = () => {
    if (!contractUpdated.value && patientContract.value?.accepted) {
      showContractModal.value = false;
    }
  };

  const acceptContract = async () => {
    try {
      await $axios.get('/api/v1/accept-terms');
      if (patientContract.value) {
        patientContract.value.accepted = true;
        patientContract.value.accepted_at = new Date().toISOString();
      }
      if (userStore.contractTherapeutic) {
        userStore.contractTherapeutic.accepted = true;
        userStore.contractTherapeutic.accepted_at = new Date().toISOString();
      }
      contractUpdated.value = false;
      showContractModal.value = false;
      await loadContract();
    } catch (error) {
      console.error('Erro ao aceitar contrato:', error);
    }
  };

  return {
    showContractModal,
    patientContract,
    contractUpdated,
    checkContract,
    loadContract,
    openContractModal,
    closeContractModal,
    acceptContract
  };
};
